import { TEnterDrawConfig, TEnterDrawParsedConfig } from './types';

export const parseConfig = (config: TEnterDrawConfig): TEnterDrawParsedConfig => {
    const {
        title,
        tags: {
            mainTag,
            secondaryTags
        } = {},
        contactPopup: {
            showContactPopup,
            contactPopupKQCText
        } = {},
        ctaMessages: {
            optedInCTAText,
            disabledCTAText,
            optInCTAText
        } = {},
        popupMessages: {
            successPopupTitleText,
            successPopupText,
            successPopupCTAText,

            errorPopupTitleText,
            errorPopupText,
            errorPopupCTAText
        } = {},
        showLoginForGuest,
        successCTACallback,
        cta: {
            ctaConfiguration,
            url: navigateUrl,
            gameCode
        } = {}
    } = config;

    return {
        title,
        mainTag,
        secondaryTags,
        contactPopupKQCText,
        optedInCTAText,
        disabledCTAText,
        optInCTAText,
        successPopupTitleText,
        successPopupText,
        successPopupCTAText,
        errorPopupTitleText,
        errorPopupText,
        errorPopupCTAText,
        showLoginForGuest,
        showContactPopup,
        successCTACallback,
        ctaConfiguration,
        navigateUrl,
        gameCode
    };
};
